module.exports = __webpack_public_path__ + "img/reset.b26899ed.svg";